import { render, staticRenderFns } from "./BannerSettings.vue?vue&type=template&id=359c970c&scoped=true&"
import script from "./BannerSettings.vue?vue&type=script&lang=js&"
export * from "./BannerSettings.vue?vue&type=script&lang=js&"
import style0 from "./BannerSettings.vue?vue&type=style&index=0&id=359c970c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c970c",
  null
  
)

export default component.exports